module.exports = __webpack_public_path__ + "img/galery-msu3-3-zoom.f7215d1e.png";